import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from '@/app/providers';
import { criarQueryClient, type TratamentoDeErros } from '@/app/query-client';
import { criarRoteador } from '@/app/router';
import { ErroDeConfiguracao } from '@/components/comuns/ErroDeConfiguracao';
import { criarAoNaoAutenticado, criarAoSemPermissao } from '@/features/auth/sessao-expirada';
import { criarBuscador, criarCliente } from '@/lib/api/cliente';
import { criarClienteDeAuth } from '@/lib/auth';
import { lerConfig } from '@/lib/config';
import { aplicarTema } from '@/lib/tema';
import '@/styles/base.css';

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('Elemento #raiz não encontrado no index.html');

aplicarTema();
const leitura = lerConfig();

if (!leitura.ok) {
  // Sem configuração válida o painel não abre pela metade (spec 000, CA-12).
  createRoot(raiz).render(
    <StrictMode>
      <ErroDeConfiguracao problemas={leitura.problemas} />
    </StrictMode>,
  );
} else {
  const servicos = {
    api: criarCliente(),
    auth: criarClienteDeAuth({ buscar: criarBuscador() }),
    config: leitura.config,
  };
  // O tratamento central do 401 precisa do roteador, que precisa do QueryClient: liga depois.
  const tratamento: TratamentoDeErros = {};
  const queryClient = criarQueryClient(tratamento);
  const roteador = criarRoteador({ ...servicos, queryClient });
  tratamento.aoNaoAutenticado = criarAoNaoAutenticado(queryClient, roteador);
  tratamento.aoSemPermissao = criarAoSemPermissao(queryClient);

  createRoot(raiz).render(
    <StrictMode>
      <Providers servicos={servicos} queryClient={queryClient}>
        <RouterProvider router={roteador} />
      </Providers>
    </StrictMode>,
  );
}
